export default __webpack_public_path__ + "static/media/black-tee.327dcd38.jpg";